// @flow
import React from 'react';
import DonorsChoose from 'action-opps-donors-choose.svg';
import Kiva from 'action-opps-kiva.svg';
import Nycparks from 'action-opps-nycparks.svg';
import GlobalGiving from 'action-opps-global-giving.svg';
import VolunteerMatch from 'action-opps-volunteermatch.svg';
import MoveOn from 'action-opps-move-on.svg';
import PointsOfLight from 'action-opps-points-of-light.svg';
import Aarp from 'action-opps-aarp.svg';
import DoSomething from 'action-opps-do-something.svg';
import Icon from 'components/Icon';

const getIconComponent = name => {
  switch (name) {
    case 'kiva':
      return Kiva;
    case 'nycparks':
      return Nycparks;
    case 'global-giving':
      return GlobalGiving;
    case 'volunteermatch':
      return VolunteerMatch;
    case 'move-on':
      return MoveOn;
    case 'points-of-light':
      return PointsOfLight;
    case 'aarp':
      return Aarp;
    case 'do-something':
      return DoSomething;
    case 'donors-choose':
    default:
      return DonorsChoose;
  }
};

const VolopsIcon = ({ name, ...props }: { name: string }) => (
  <Icon component={getIconComponent(name)} {...props} />
);

export default VolopsIcon;
